module.exports = __webpack_public_path__ + "static/media/1C.e992e7f1.jpg";